import * as React from "react";
const SvgTempChilled20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M16.982 5a1.5 1.5 0 0 1-1.42 1.498V6.5H2.032v2h13.565v-.002a3.5 3.5 0 1 0-3.58-3.998h2.05a1.5 1.5 0 0 1 2.915.5ZM14.07 15a1 1 0 1 1-1 1h-2a3 3 0 1 0 3-3H2.031v2H14.07Zm-3.116-5.26H2.032v2h8.922v-2Z"
    })
  );
export default SvgTempChilled20Px;
